import React, {useCallback, useEffect, useMemo, useState} from 'react';
import {
    MaterialReactTable,
    MRT_GlobalFilterTextField,
    MRT_ToggleFiltersButton,
    MRT_ToolbarAlertBanner
} from 'material-react-table';
import {MRT_Localization_RU} from "material-react-table/locales/ru";
import {Button, Paper, Tooltip, tooltipClasses} from "@mui/material";
import Box from "@mui/material/Box";
import {Link, useLocation, useNavigate} from "react-router-dom";
import WorkingCuttingMapService from "../../../../../API/orders/cutting/cuttingmap/WorkingCuttingMapService";
import {structure} from "../../../../../data/Structure";
import {workingCuttingMapStatuses} from "../../../../../data/WorkingCuttingMapStatuses";
import ModalConfirm from "../../../modal/ModalConfirm";
import ModalFinishCutCuttingMap from "./ModalFinishCutCuttingMap";
import MaterialWarehouseService from "../../../../../API/orders/warehouse/material/MaterialWarehouseService";
import DriveFileMoveIcon from '@mui/icons-material/DriveFileMove';
import ButtonCreate from "../../../button/ButtonCreate";
import MenuItem from "@mui/material/MenuItem";
import {useIsAccessGranted} from "../../../../../utils/useIsAccessGranted";
import {styled} from "@mui/system";
import {calcFilterData} from "../../../../../utils/common/calcFilterData";
import selectionTableUtil, {normalizeSelection} from "../../../../../utils/common/SelectionTableUtil";
import ButtonSelectAction from "../../../button/ButtonSelectAction";
import {ModalSelectAction} from "../../../modal/ModalSelectAction";
import MaterialReserveService from "../../../../../API/orders/reservation/MaterialReserveService";
import NameModal from "../../../modal/NameModal";

const CustomWidthTooltip = styled(({className, ...props}) => (
    <Tooltip {...props} classes={{popper: className}}/>
))({
    [`& .${tooltipClasses.tooltip}`]: {
        maxWidth: 1000,
        fontSize: "18px"
    },
});
const WorkingCuttingMapTable = ({
                                    data,
                                    setData,
                                    isCalculation,
                                    disabledEdit,
                                    archive,
                                    queue,
                                    minNumberCutting,
                                    maxNumberCutting,
                                    unableCut,
                                    setUnableCut,
                                    tableOptions,
                                    tableOptionsHandle,
                                    handleModalAlert,
                                    enableRowSelection,
                                    globalFilter,
                                    handleSearchQuery,
                                    filteredData,
                                    columnsFilter
                                }) => {
    const [rowSelection, setRowSelection] = useState([]);
    const isAllowed = useIsAccessGranted(["ROLE_ORGANIZATION_USER_CUT", "ROLE_ORGANIZATION_USER_OPTIMIZATION"])
    const isOptimizationUser = useIsAccessGranted(["ROLE_ORGANIZATION_USER_OPTIMIZATION"])
    const [open, setOpen] = useState(false)
    const [showColumnFilters, setShowColumnFilters] = useState(false)

    const handleShowColumnFilters = () => {
        setShowColumnFilters(!showColumnFilters)
        if (showColumnFilters) {
            handleSearchQuery([], data, null, true)
        }
    }

    const {onRowSelectionChange} = selectionTableUtil(data, setRowSelection)
    const currentSelection = normalizeSelection(rowSelection)

    const handleDeleteRow = useCallback(
        (row) => {
            WorkingCuttingMapService.delete(row.original.id)
                .then(function () {
                    data.splice(row.index, 1);
                    const newData = [...data];
                    setData(newData);
                    handleSearchQuery(globalFilter, newData)
                })
                .catch(function (error) {
                    handleModalAlert(error);
                })
        },
        [data],
    );

    const raiseCuttingPriority = useCallback(
        (row, data) => {
            WorkingCuttingMapService.raiseCuttingPriority(row.original.id)
                .then(function () {
                    const index = row.index;
                    if (row.index - 1 > -1) {
                        const newData = [...data];
                        newData[index].numberCutting -= 1;
                        newData[index - 1].numberCutting += 1;
                        const movedItem = newData.splice(index, 1)[0];
                        newData.splice(index - 1, 0, movedItem);
                        setData(newData);
                        handleSearchQuery(globalFilter, newData)
                    }
                    handleModalAlert("Карта поднята выше", 'success')
                })
                .catch(function (error) {
                    handleModalAlert(error);
                })
        },
        [setData],
    );

    const returnForRevision = useCallback(
        (row) => {
            setCurrentIdRow(row.original.id);
            setModalOpenReturnForRevision(true)
        },
        [data],
    );

    const handleCloseReturnForRevision = () => {
        setCurrentIdRow(null);
        setModalOpenReturnForRevision(false);
    };

    const lowerCuttingPriority = useCallback(
        (row, data) => {
            WorkingCuttingMapService.lowerCuttingPriority(row.original.id)
                .then(function () {
                    const index = row.index;
                    if (row.index - 1 < data.length) {
                        const newData = [...data];
                        newData[index + 1].numberCutting -= 1;
                        newData[index].numberCutting += 1;
                        const movedItem = newData.splice(index, 1)[0];
                        newData.splice(index + 1, 0, movedItem);
                        setData(newData);
                        handleSearchQuery(globalFilter, newData)
                    }
                    handleModalAlert("Карта опущена ниже", 'success')
                })
                .catch(function (error) {
                    handleModalAlert(error);
                })
        },
        [setData],
    );

    const navigate = useNavigate();

    const redirectCutFiles = (row) => {
        const archiveQuery = archive ? '?from=archive' : '';
        navigate('/organization/working-cutting-map/' + row.original.id + '/' + encodeURIComponent(row.original.materialName) + '/cut-files' + archiveQuery);
    };

    const checkDelete = (row) => {
        const workingCuttingMapState = row.original.workingCuttingMapState
        return workingCuttingMapState === 'EXPECTATION' || workingCuttingMapState === 'MAPS_CANCEL' || workingCuttingMapState === 'RESERVES_CANCEL'
            || workingCuttingMapState === 'CALCULATION' || workingCuttingMapState === 'CALCULATION_RESERVES_CANCEL';
    };

    const [currentIdRow, setCurrentIdRow] = useState(null);
    const [modalOpenSetForCutting, setModalOpenSetForCutting] = useState(false);
    const [modalOpenSetStartCutting, setModalOpenSetStartCutting] = useState(false);
    const [startCuttingMapName, setStartCuttingMapName] = useState(null);
    const [modalOpenSendToArchive, setModalOpenSendToArchive] = useState(false);
    const [modalOpenPurchase, setModalOpenPurchase] = useState(false);
    const [modalOpenCut, setModalOpenCut] = useState(false);
    const [modalApprove, setModalApprove] = useState(false);
    const [modalNoteOpen, setModalNoteOpen] = useState(false);
    const [currentNoteRow, setCurrentNoteRow] = useState(null);
    const [noteLoading, setNoteLoading] = useState(false);

    const setForCutting = useCallback(
        (row) => {
            setCurrentIdRow(row.original.id);
            setModalOpenSetForCutting(true)
        },
        [data],
    );

    const setStartCutting = useCallback(
        (row) => {
            setCurrentIdRow(row.original.id);
            setStartCuttingMapName(`${row.original.number} (${row.original.materialName})`);
            setModalOpenSetStartCutting(true)
        },
        [],
    );

    const handleSubmitSetForCutting = async () => {
        const api = currentIdRow ? WorkingCuttingMapService.setForCutting : WorkingCuttingMapService.setForCuttingByIds
        const value = currentIdRow ? currentIdRow : rowSelection

        api(value)
            .then(function () {
                if (currentIdRow) {
                    const newData = data.filter(el => el.id !== currentIdRow)
                    setData(newData)
                    handleSearchQuery(globalFilter, newData)
                    setCurrentIdRow(null)
                } else {
                    const newData = data.filter(el => !rowSelection.includes(el.id))
                    setData(newData)
                    handleSearchQuery(globalFilter, newData)
                    setRowSelection([])
                    setOpen(false)
                }

                tableOptionsHandle((prev) => ({...prev, totalElements: data.length - 1}))
                setModalOpenSetForCutting(false);
                handleModalAlert("Карта отправлена на раскрой", 'success')
            })
            .catch(function (error) {
                handleModalAlert(error);
            })
    };

    const handleCloseSetForCutting = () => {
        setCurrentIdRow(null);
        setModalOpenSetForCutting(false);
    };

    const handleSubmitReturnForRevision = async () => {
        const api = currentIdRow ? WorkingCuttingMapService.returnForRevision : WorkingCuttingMapService.returnForRevisionByIds
        const value = currentIdRow ? currentIdRow : rowSelection

        api(value).then(function () {
            if (currentIdRow) {
                setCurrentIdRow(null)
                const newData = data.filter(el => el.id !== currentIdRow)
                setData(newData)
                handleSearchQuery(globalFilter, newData)
            } else {
                const newData = data.filter(el => !rowSelection.includes(el.id))
                setData(newData)
                handleSearchQuery(globalFilter, newData)
                setRowSelection([])
                setOpen(false)
            }

            tableOptionsHandle((prev) => ({...prev, totalElements: data.length - 1}))
            setModalOpenReturnForRevision(false);
            handleModalAlert("Карта отправлена на доработку", 'success')
        })
            .catch(function (error) {
                handleModalAlert(error);
            })
    };

    const [modalOpenReturnForStartCutting, setModalOpenReturnForStartCutting] = useState(false);

    const returnReturnForStartCutting = useCallback(
        (row) => {
            setCurrentIdRow(row.original.id);
            setModalOpenReturnForStartCutting(true)
        },
        [data],
    );

    const handleCloseReturnForStartCutting = () => {
        setCurrentIdRow(null);
        setModalOpenReturnForStartCutting(false);
    };

    const [modalOpenReturnForRevision, setModalOpenReturnForRevision] = useState(false);

    const handleSubmitReturnForStartCutting = async () => {
        const api = WorkingCuttingMapService.returnForStartCutting
        const value = currentIdRow;

        api(value).then(function () {
            if (currentIdRow) {
                const newData = data.map(el => el.id === currentIdRow ? {
                    ...el,
                    workingCuttingMapState: 'FOR_CUTTING'
                } : el)
                setData(newData)
                handleSearchQuery(globalFilter, newData)
            }
            handleCloseReturnForStartCutting();
            handleModalAlert("Начало раскроя отменено", 'success')
        })
            .catch(function (error) {
                handleModalAlert(error);
            })
    };

    const handleSubmitSetStartCutting = async () => {
        const api = currentIdRow ? WorkingCuttingMapService.setStartCutting : WorkingCuttingMapService.setStartCuttingByIds
        const value = currentIdRow ? currentIdRow : rowSelection

        api(value).then(function () {
            if (currentIdRow) {
                const newData = data.map(el => el.id === currentIdRow ? {
                    ...el,
                    workingCuttingMapState: 'CUTTING_STARTED'
                } : el)
                setData(newData)
                handleSearchQuery(globalFilter, newData)
            } else {
                const newData = data.map(el => rowSelection.includes(el.id) ? {
                    ...el,
                    workingCuttingMapState: 'CUTTING_STARTED'
                } : el)
                setData(newData)
                handleSearchQuery(globalFilter, newData)
                setRowSelection([])
                setOpen(false)
            }
            handleCloseSetStartCutting();
            handleModalAlert("Начало раскроя подтверждено", 'success')
        })
            .catch(function (error) {
                handleModalAlert(error);
            })
    };

    const handleSubmitSendToArchive = async () => {
        const api = currentIdRow ? WorkingCuttingMapService.sendToArchive : WorkingCuttingMapService.sendToArchiveByIds
        const value = currentIdRow ? currentIdRow : rowSelection

        api(value)
            .then(function () {
                if (currentIdRow) {
                    const newData = data.filter(el => el.id !== currentIdRow)
                    setData(newData)
                    handleSearchQuery(globalFilter, newData)
                } else {
                    const newData = data.filter(el => !rowSelection.includes(el.id))
                    setData(newData)
                    handleSearchQuery(globalFilter, newData)
                    setRowSelection([])
                    setOpen(false)
                }

                tableOptionsHandle((prev) => ({...prev, totalElements: data.length - 1}))
                handleCloseModalToArchive();
                handleModalAlert("Карта отправлена в ахив", 'success')
            })
            .catch(function (error) {
                handleModalAlert(error);
            })
    };
    const handleSubmitModalPurchase = async () => {
        const api = MaterialReserveService.sendPurchaseByIds
        const value = currentIdRow ? [currentIdRow] : rowSelection

        api(value)
            .then(function () {
                if (!currentIdRow) {
                    setRowSelection([])
                    setOpen(false)
                }
                handleCloseModalPurchase();
                handleModalAlert("Резервы отправлены на закупку", 'success')
            })
            .catch(function (error) {
                handleModalAlert(error);
            })
    };
    const handleSubmitModalApprove = async () => {
        const api = WorkingCuttingMapService.approveByIds
        const value = currentIdRow ? [currentIdRow] : rowSelection

        api(value)
            .then(function () {
                if (!currentIdRow) {
                    const newData = data.map(el => rowSelection.includes(el.id) ? {
                        ...el,
                        workingCuttingMapState: 'MAPS_APPROVED'
                    } : el)
                    setData(newData)
                    handleSearchQuery(globalFilter, newData)
                    setRowSelection([])
                    setOpen(false)
                } else {
                    const newData = data.map(el => el.id === currentIdRow ? {
                        ...el,
                        workingCuttingMapState: 'MAPS_APPROVED'
                    } : el)
                    setData(newData)
                    handleSearchQuery(globalFilter, newData)
                }
                handleCloseModalApprove();
                handleModalAlert("Карты подтверждены", 'success')
            })
            .catch(function (error) {
                handleModalAlert(error);
            })

    };
    const handleSubmitModalOpenCut = async () => {
        const api = WorkingCuttingMapService.cutByIds
        const value = currentIdRow ? [currentIdRow] : rowSelection

        api(value)
            .then(function (response) {
                if (currentIdRow) {
                    const newData = data.map(el => el.id === response.data[0]?.id ? {...el, ...response.data[0]} : el)
                    setData(newData)
                    handleSearchQuery(globalFilter, newData)
                    handleModalAlert("Карта раскроена", 'success')
                } else {
                    const newData = data.map(el => ({...el, ...response.data.find(respEl => respEl?.id === el.id)} || el))
                    setData(newData)
                    handleSearchQuery(globalFilter, newData)
                    setRowSelection([])
                    setOpen(false)
                    handleModalAlert("Карты раскроены", 'success')
                }
                handleCloseModalOpenCut();
            })
            .catch(function (error) {
                handleModalAlert(error);
            })
    };


    const handleCloseSetStartCutting = () => {
        setCurrentIdRow(null);
        setStartCuttingMapName(null);
        setModalOpenSetStartCutting(false);
    };

    const columns = useMemo(() => {
        const baseColumns = [
            {
                id: 'number',
                header: 'Номер',
                accessorKey: 'number',
                minSize: 15,
                maxSize: 15,

                sx: {
                    p: '0px 0px 0px 0px',
                    m: '0px',
                },
                Cell: ({cell, row}) => (
                    <Link
                        to={'/organization/working-cutting-map/' + row.original.id + '/' + encodeURIComponent(row.original.materialName) + "/" + row.original.number + "/" + row.original.materialOId}>{cell.getValue()}</Link>
                ),
            },
            {
                id: 'materialName',
                header: 'Материал',
                accessorKey: 'materialName',
                minSize: 350,
                sx: {
                    p: '0px 0px 0px 0px',
                    m: '0px',
                },

                Cell: ({cell, row}) => {
                    return (
                        <Link
                            to={'/organization/materials/' + row.original.materialOId + '/кв.м/SLAB/' + row.original.materialId}>{cell.getValue()}</Link>
                    )
                }

            },
            {
                id: 'materialStructure',
                header: 'Структура',
                accessorKey: 'materialStructure',
                minSize: 15,
                maxSize: 15,
                sx: {
                    p: '0px 0px 0px 0px',
                    m: '0px',
                },
                Cell: ({cell}) => structure[cell.getValue()],
            },
            {
                id: 'workingCuttingMapState',
                header: 'Статус',
                accessorKey: 'workingCuttingMapState',
                maxSize: 150,
                sx: {
                    p: '0px 0px 0px 0px',
                    m: '0px',
                },
                Cell: ({cell}) => workingCuttingMapStatuses[cell.getValue()],
                filterFn: (row, id, filterValue) => {
                    return workingCuttingMapStatuses[row.original.workingCuttingMapState].toLowerCase().includes(filterValue.toLowerCase())
                },
            },
            {
                id: 'optimization',
                header: 'Оптимизация',
                accessorKey: 'optimization.number',
                minSize: 15,
                maxSize: 15,
                sx: {
                    p: '0px 0px 0px 0px',
                    m: '0px',
                },
                Cell: ({cell, row}) => (
                    <Link
                        to={'/organization/details/optimization/' + row.original.optimization.id + '/' + encodeURIComponent(row.original.optimization.number)}>{cell.getValue()}</Link>
                ),
            },
            {
                id: 'optimizationQuantity',
                header: 'Опт. кв.м',
                accessorKey: 'optimizationQuantity',
                minSize: 15,
                maxSize: 15,
                sx: {
                    p: '0px 0px 0px 0px',
                    m: '0px',
                },
                Cell: ({cell}) => cell.getValue() === null ? null : parseFloat(cell.getValue()).toFixed(3),
            },
            {
                id: 'note',
                header: 'Комментарий',
                accessorFn: (row) => row.note ?? '',
                minSize: 250,
                sx: {
                    p: '0px 0px 0px 0px',
                    m: '0px',
                },
                Cell: ({cell}) => {
                    const value = cell.getValue();
                    if (!value) {
                        return null;
                    }
                    return (
                        <CustomWidthTooltip arrow placement="top" title={value}>
                            <Box
                                sx={{
                                    width: "280px",
                                    overflow: "clip",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap"
                                }}
                            >
                                {value}
                            </Box>
                        </CustomWidthTooltip>
                    );
                },
                filterFn: (row, id, filterValue) => {
                    return (row.original.note || '').toLowerCase().includes(filterValue.toLowerCase())
                },
            },
            {
                id: 'orders',
                header: 'Заказы',
                accessorKey: 'orderNumbers',
                minSize: 550,
                sx: {
                    p: '0px 0px 0px 0px',
                    m: '0px',
                },
                Cell: ({cell, row}) => <CustomWidthTooltip
                    arrow
                    placement="top"
                    title={cell.getValue()}><Box
                    sx={{
                        width: "600px",
                        overflow: "clip",
                        textOverflow: "ellipsis"
                    }}>{cell.getValue()}</Box></CustomWidthTooltip>
            },
            {
                id: 'numberCutting',
                header: 'приоритет',
                accessorKey: 'numberCutting',
                minSize: 15,
                enableHiding: false,
                sx: {
                    p: '0px 0px 0px 0px',
                    m: '0px',
                },
            },
            {
                header: 'id',
                id: 'id',
                accessorKey: 'id',
                enableHiding: false,
                enableSorting: false,
                enableColumnActions: false,
                enableGrouping: false,
                enableEditing: false,
            },
        ];

        baseColumns.splice(6, 0, {
            id: 'nominalQuantity',
            header: 'Номинал кв.м',
            accessorKey: 'nominalQuantity',
            minSize: 15,
            sx: {
                p: '0px 0px 0px 0px',
                m: '0px',
            },
            Cell: ({cell}) => cell.getValue() === null ? null : cell.getValue().toFixed(3),
        });

        if (queue || archive) {
            baseColumns.splice(7, 0, {
                id: 'file',
                header: 'Файлы',
                accessorKey: 'file',
                minSize: 15,
                maxSize: 15,
                sx: {
                    p: '0px 0px 0px 0px',
                    m: '0px',
                },
                enableSorting: false,
                Cell: ({row}) => (
                    <Button
                        size="small"
                        sx={{minWidth: 'auto', marginLeft: 'auto'}}
                        color="pencil"
                        onClick={() => redirectCutFiles(row)}
                    >
                        <DriveFileMoveIcon sx={{minWidth: 'auto', marginLeft: 'auto', fontSize: 20}}/>
                    </Button>
                ),
            });
        }

        return baseColumns;

    }, [data, setData, queue, archive, filteredData]);

    const [modalOpenFinishCutCuttingMap, setModalOpenFinishCutCuttingMap] = useState(false);
    const [finishCuttingMapName, setFinishCuttingMapName] = useState(null);
    const [markedWorkers, setMarkedWorkers] = useState({});

    const setFinishCutCuttingMap = useCallback(
        (row) => {
            setCurrentIdRow(row.original.id);
            setFinishCuttingMapName(`${row.original.number} (${row.original.materialName})`);
            setModalOpenFinishCutCuttingMap(true);
        },
        [],
    );

    const handleSubmitSetFinishCut = async (performJob, markedWorkers = {}) => {
        const body = Object.keys(markedWorkers).length === 0
            ? {ids: null}
            : {ids: markedWorkers};
        WorkingCuttingMapService.setFinishCut(currentIdRow, performJob, body)
            .then(function (response) {
                const updatedRow = response.data;
                const newData = data.map(el => el.id === currentIdRow ? {...el, ...updatedRow} : el)
                setData(newData)
                handleSearchQuery(globalFilter, newData)
                handleCloseSetFinishCut();
                handleModalAlert("Раскрой подтверждён", 'success')
            })
            .catch(function (error) {
                handleModalAlert(error);
            })
    };

    const handleCloseSetFinishCut = () => {
        setCurrentIdRow(null);
        setFinishCuttingMapName(null);
        setModalOpenFinishCutCuttingMap(false);
        setMarkedWorkers({});
    };

    const openModalToArchive = useCallback(
        (row) => {
            setCurrentIdRow(row.original.id);
            setModalOpenSendToArchive(true);
        },
        [data],
    );
    const openModalToPurchase = useCallback(
        (row) => {
            setCurrentIdRow(row.original.id);
            setModalOpenPurchase(true);
        },
        [data],
    );
    const approve = useCallback(
        (row) => {
            setCurrentIdRow(row.original.id);
            setModalApprove(true);
        },
        [data],
    );

    const cutMap = useCallback(
        (row) => {
            setCurrentIdRow(row.original.id);
            setModalOpenCut(true);
        },
        [data],
    );
    const handleCloseModalToArchive = () => {
        setCurrentIdRow(null);
        setModalOpenSendToArchive(false);
    };
    const handleCloseModalPurchase = () => {
        setCurrentIdRow(null);
        setModalOpenPurchase(false);
    }
    const handleCloseModalApprove = () => {
        setCurrentIdRow(null);
        setModalApprove(false);
    }
    const handleCloseModalOpenCut = () => {
        setCurrentIdRow(null);
        setModalOpenCut(false);
    }

    const refreshTableData = useCallback(() => {
        const api = queue
            ? WorkingCuttingMapService.getAllForCuttingWithOptimization
            : WorkingCuttingMapService.getAll;
        return api().then(function (response) {
            const newData = response.data;
            setData(newData);
            handleSearchQuery(globalFilter, newData);
        });
    }, [queue, globalFilter, handleSearchQuery, setData]);

    const recreateCuttingMap = useCallback(
        (row) => {
            WorkingCuttingMapService.recreate(row.original.id)
                .then(function () {
                    return refreshTableData();
                })
                .then(function () {
                    handleModalAlert("Карты пересозданы", 'success');
                })
                .catch(function (error) {
                    handleModalAlert(error);
                });
        },
        [refreshTableData, handleModalAlert],
    );

    const handleCreateNote = useCallback((row) => {
        setCurrentNoteRow(row.original);
        setModalNoteOpen(true);
    }, []);

    const handleCloseNoteModal = () => {
        setModalNoteOpen(false);
        setCurrentNoteRow(null);
    };

    const handleSubmitNote = (formData) => {
        setNoteLoading(true);
        WorkingCuttingMapService.setNote(currentNoteRow.id, formData.name)
            .then(function () {
                const newData = data.map(el => el.id === currentNoteRow.id ? {...el, note: formData.name} : el);
                setData(newData);
                handleSearchQuery(globalFilter, newData);
                handleModalAlert("Комментарий создан", 'success');
            })
            .catch(function (error) {
                handleModalAlert(error);
            })
            .finally(() => setNoteLoading(false));
    };

    const recreateMenuItem = isOptimizationUser
        ? [{type: "recreate", text: "Пересоздать карты", handler: recreateCuttingMap}]
        : [];

    const noteMenuItem = [{type: "note", text: "Создать комментарий", handler: handleCreateNote}];

    const menuItem = queue ? [
        {type: "return", text: "Вернуть карту на доработку", handler: returnForRevision},
        {type: "raise", text: "Поднять карту выше", handler: raiseCuttingPriority},
        {type: "lower", text: "Опустить карту ниже", handler: lowerCuttingPriority},
        {type: "start", text: "Начать раскрой карты", handler: setStartCutting},
        {type: "returnStart", text: "Отменить начало раскроя карты", handler: returnReturnForStartCutting},
        {type: "finish", text: "Подтвердить раскрой карты", handler: setFinishCutCuttingMap},
        {type: "archive", text: "Поместить в архив", handler: openModalToArchive},
        {type: "purchase", text: "Отправить на закупку резервы карты раскроя", handler: openModalToPurchase},
        ...noteMenuItem,
        ...recreateMenuItem,
    ] : [
        {text: "Раскроить", type: "cut", handler: cutMap},
        {text: "Подтвердить карты", type: "approve", handler: approve},
        {text: "Отправить на закупку резервы", type: "purchase", handler: openModalToPurchase},
        {type: "send", text: "Отправить карту на раскрой", handler: setForCutting},
        {type: "delete", text: "Удалить", handler: handleDeleteRow},
        ...noteMenuItem,
        ...recreateMenuItem,
    ]

    const modalActions = queue ? [
        {type: "return", name: "Вернуть карту на доработку"},
        {type: "start", name: "Начать раскрой карты"},
        {type: "archive", name: "Поместить в архив"},
        {type: "purchase", name: "Отправить на закупку резервы карт раскроя"},
    ] : [{name: "Раскроить", type: "cut"},
        {name: "Подтвердить карты", type: "approve"},
        {name: "Отправить на закупку резервы", type: "purchase"},
        {name: "Отправить карту на раскрой", type: "send"},]

    const handleSelectAction = (type) => {
        if (type === "return") {
            setModalOpenReturnForRevision(true)
        } else if (type === "start") {
            setModalOpenSetStartCutting(true)
        } else if (type === "archive") {
            setModalOpenSendToArchive(true);
        } else if (type === "purchase") {
            setModalOpenPurchase(true);
        } else if (type === "cut") {
            setModalOpenCut(true);
        } else if (type === "approve") {
            setModalApprove(true)
        } else {
            setModalOpenSetForCutting(true)
        }
    }

    return (
        <Box sx={{maxWidth: queue ? "2300px" : "2000px"}}>
            <Box
                sx={{display: 'flex', justifyContent: "flex-end", paddingBottom: "30px"}}
            >
                <Box sx={{display: 'flex', justifyContent: "spase-between", gap: "9px"}}>
                    <ButtonCreate
                        text={"Заказы"}
                        width={70}
                        icon={false}
                        onClick={() => navigate('/organization/orders')}
                    />
                    {!isCalculation &&
                        <ButtonCreate
                            text={"Заявки на раскрой"}
                            width={160}
                            icon={false}
                            onClick={() => navigate('/organization/requests-cutting')}
                        />}
                    {isCalculation &&
                        <ButtonCreate
                            text={"Рас. заявки на раскрой"}
                            width={200}
                            icon={false}
                            onClick={() => navigate('/organization/requests-cutting/Calculation')}
                        />}
                    {!isCalculation && <ButtonCreate
                        text={"Планы"}
                        width={70}
                        icon={false}
                        onClick={() => navigate('/organization/plans')}
                    />}

                    {isCalculation && <ButtonCreate
                        text={"Рас.оптимизации"}
                        width={150}
                        icon={false}
                        onClick={() => navigate('/organization/optimizations-calculation')}
                    />}
                    {!isCalculation && <ButtonCreate
                        text={"Оптимизации"}
                        width={120}
                        icon={false}
                        onClick={() => navigate('/organization/optimizations')}
                    />}

                    {!archive && <ButtonCreate
                        text={"Архив"}
                        width={70}
                        icon={false}
                        onClick={() => isCalculation ? navigate('/organization/working-cutting-maps-calculation-archive') : navigate('/organization/working-cutting-maps-archive')}
                    />}

                </Box>
            </Box>
            <MaterialReactTable
                renderTopToolbar={({table}) => {
                    return <Box sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        padding: "7px",
                        backgroundColor: (theme) => table.getSelectedRowModel().rows.length > 0 ? theme.palette.primary.light : "transparent",
                    }}>
                        <MRT_ToolbarAlertBanner table={table}/>
                        <Box sx={{display: "flex"}}>
                            <MRT_ToggleFiltersButton table={table}/>
                            <MRT_GlobalFilterTextField table={table}/>
                        </Box>
                    </Box>
                }}
                selectAllMode={"all"}
                muiTableContainerProps={{
                    sx: {
                        width: queue ? "2300px" : "2000px",
                        maxHeight: rowSelection?.length > 0 ? `calc(100vh - 550px)` : `calc(100vh - 450px)`,
                    }
                }}
                muiTopToolbarProps={{
                    sx: {
                        "& .MuiBox-root": {
                            padding: 0
                        }
                    }
                }}
                muiTableBodyCellProps={({cell, table}) => {
                    return ({
                        sx: () => ({
                            p: '0px 0px 0px 10px',
                            m: '0px 0px 0px 0px',
                            border: "none",
                            "&:after": {
                                display: "none",
                            },
                            "& td:after": {
                                "&:hover": {
                                    backgroundColor: "red"
                                }
                            },
                            "&:not(:last-of-type)": {
                                borderRight: '1px solid #EAEBEA',
                            },

                            "&:first-of-type": {
                                padding: 0,
                                width: "50px",
                                height: "36px",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                color: (theme) => theme.palette.text.light,
                                "& .MuiButtonBase-root": {
                                    borderRadius: "4px",
                                    width: "24px",
                                    height: "24px",
                                    opacity: 1,
                                    margin: 0,
                                    padding: 0,
                                    "&:hover": {
                                        backgroundColor: (theme) => theme.palette.primary.stroke,
                                    }
                                }
                            },

                            "& a": {
                                color: "#006CCC",
                                textDecoration: "none",
                                "&:hover": {
                                    textDecoration: "underline"
                                }

                            }
                        })
                    })
                }}
                muiTableHeadCellProps={{
                    sx: {
                        border: '1px solid #EAEBEA',
                        backgroundColor: "#F5F6FA",
                        padding: "10px",
                        paddingBottom: " 0.2rem",
                        paddingTop: "0.2rem",
                        "&:first-of-type .Mui-TableHeadCell-Content-Wrapper": {
                            "minWidth": "100%"
                        },
                        "& .MuiCollapse-root .MuiSelect-select": {
                            padding: "0 !important",
                            "& .MuiChip-label": {
                                paddingLeft: "5px",
                                paddingRight: "5px",
                            }
                        }

                    },
                }}
                muiTableBodyRowProps={({row}) => {
                    return ({
                        sx: () => ({
                            height: '36px',
                            backgroundColor: "white",
                            "&:hover& td:after": {
                                display: "none",
                            },
                            "&.MuiTableRow-root.Mui-selected": {
                                backgroundColor: (theme) => theme.palette.primary.light70,
                                "&:hover": {
                                    backgroundColor: (theme) => theme.palette.primary.light50,
                                },
                            },
                            "&:hover": {
                                "& td:after": {
                                    display: "none",
                                },
                                backgroundColor: (theme) => theme.palette.primary.stroke,
                            },
                            '&:nth-of-type(even)': {
                                "&.MuiTableRow-root.Mui-selected": {
                                    backgroundColor: (theme) => theme.palette.primary.light,
                                    "&:hover": {
                                        backgroundColor: (theme) => theme.palette.primary.light50,
                                    },
                                },
                                backgroundColor: (theme) => theme.palette.primary.lightGrey,
                                "&:hover": {
                                    backgroundColor: (theme) => theme.palette.primary.stroke,
                                },
                            },
                        })
                    })
                }}

                muiSearchTextFieldProps={{
                    placeholder: `Поиск`,
                    sx: {
                        paddingTop: "5px",
                        paddingBottom: "0px",
                        "& .MuiCollapse-root": {
                            borderRadius: '12px',
                            height: 40, width: 290,
                            "& .MuiSvgIcon-root": {
                                color: "#737478"
                            },
                            '& .MuiOutlinedInput-input': {
                                padding: 0
                            }
                        }
                    },
                    variant: 'outlined',
                }}
                displayColumnDefOptions={{
                    'mrt-row-actions': {
                        header: "",
                        size: 3,
                        minSize: 3,
                        grow: false,
                    },
                    'mrt-row-select': {
                        size: "50px",
                        grow: false,
                    },
                }}
                columns={columns}
                data={filteredData}
                enableRowSelection={enableRowSelection}
                onRowSelectionChange={onRowSelectionChange}
                onPaginationChange={(updater) => {
                    tableOptionsHandle(updater(tableOptions));
                }}
                onGlobalFilterChange={(value) => {
                    handleSearchQuery(value, data, null)
                }}
                onColumnFiltersChange={(updater) => {
                    handleSearchQuery(updater(columnsFilter), data, null, true)
                }}
                onShowColumnFiltersChange={handleShowColumnFilters}
                state={{
                    showColumnFilters: showColumnFilters,
                    columnFilters: columnsFilter,
                    globalFilter: globalFilter,
                    rowSelection: currentSelection,
                    showGlobalFilter: true,
                    pagination: tableOptions,
                }}
                manualFiltering={true}
                rowCount={tableOptions.totalElements}
                getRowId={(originalRow) => originalRow.id}
                enableRowActions={true}
                enableToolbarInternalActions={false}
                muiToolbarAlertBannerProps={{
                    sx: {
                        backgroundColor: (theme) => theme.palette.primary.light,
                        "& .MuiStack-root": {
                            padding: 0,
                        },
                    }
                }}
                renderRowActionMenuItems={({closeMenu, row}) => menuItem.map(el => {
                    const reservesCreated = ['RESERVES_CREATED', 'CALCULATION_RESERVES_CREATED'].includes(row.original.workingCuttingMapState)
                    const enabled = (el.type === "delete" && checkDelete(row))
                        || (el.type === "send" && (row.original.workingCuttingMapState === 'MAPS_APPROVED' || reservesCreated))
                        || ((el.type === "return" || el.type === "start") && row.original.workingCuttingMapState === 'FOR_CUTTING')
                        || (el.type === "raise" && row.original?.numberCutting !== minNumberCutting)
                        || (el.type === "lower" && row.original?.numberCutting !== maxNumberCutting)
                        || (el.type === "finish" && row.original.workingCuttingMapState === 'CUTTING_STARTED' && isAllowed)
                        || (el.type === "archive" && row.original.workingCuttingMapState === 'CUT_OUT')
                        || (el.type === "returnStart" && row.original.workingCuttingMapState === 'CUTTING_STARTED')
                        || (el.type === "purchase" && row.original.workingCuttingMapState === 'MAPS_APPROVED' && queue)
                        || (el.type === "purchase" && (row.original.workingCuttingMapState === 'CUT_OUT' || reservesCreated) && !queue)
                        || (el.type === "approve" && (row.original.workingCuttingMapState === 'CUT_OUT' || reservesCreated))
                        || (el.type === "cut" && ["EXPECTATION", "MAPS_CANCEL", "RESERVES_CANCEL"].includes(row.original.workingCuttingMapState))
                        || (el.type === "recreate" && isOptimizationUser)
                        || (el.type === "note")
                    return <MenuItem
                        key={el.type}
                        disabled={!enabled}
                        onClick={() => {
                            el.handler(row, filteredData)
                            closeMenu();
                        }}
                        sx={{
                            margin: "0 8px",
                            borderRadius: "4px",
                            "&:hover": {backgroundColor: (theme) => theme.palette.primary.light}
                        }}
                    >
                        {el.text}
                    </MenuItem>
                })}
                initialState={{
                    columnVisibility: {
                        id: false,
                        numberCutting: false
                    },
                    isFullScreen: false,
                    density: "compact",
                    sorting: [
                        {
                            id: 'numberCutting',
                            desc: false,
                        },]
                }}
                localization={
                    MRT_Localization_RU
                }
            />
            {Object.keys(rowSelection).length !== 0 && <Paper sx={{
                position: "absolute",
                bottom: 0,
                left: 0,
                width: '100%',
                height: "88px",
                display: 'flex',
                justifyContent: "center",
                alignItems: 'center',
                backgroundColor: (theme) => theme.palette.primary.lightGrey,
            }} component="footer">
                <ButtonSelectAction text={"Выбрать действие"} onClick={() => setOpen(true)}/>
            </Paper>}
            <ModalSelectAction
                open={open}
                reset={() => setOpen(false)}
                submit={handleSelectAction}
                modalActions={modalActions}
            />
            <ModalConfirm
                title={"Подтвердить отправить карту на раскрой?"}
                modalOpen={modalOpenSetForCutting}
                handleClose={handleCloseSetForCutting}
                handleSubmit={handleSubmitSetForCutting}
                action={"Подтвердить"}
            />
            <ModalConfirm
                title={"Подтвердить вернуть карту раскроя на доработку?"}
                modalOpen={modalOpenReturnForRevision}
                handleClose={handleCloseReturnForRevision}
                handleSubmit={handleSubmitReturnForRevision}
                action={"Подтвердить"}
            />
            <ModalConfirm
                title={"Подтвердить отменить старт карты раскроя?"}
                modalOpen={modalOpenReturnForStartCutting}
                handleClose={handleCloseReturnForStartCutting}
                handleSubmit={handleSubmitReturnForStartCutting}
                action={"Подтвердить"}
            />
            <ModalConfirm
                title={startCuttingMapName
                    ? `Подтвердить начало раскроя «${startCuttingMapName}»?`
                    : "Подтвердить начало раскроя?"}
                modalOpen={modalOpenSetStartCutting}
                handleClose={handleCloseSetStartCutting}
                handleSubmit={handleSubmitSetStartCutting}
                action={"Подтвердить"}
            />
            <ModalConfirm
                title={"Подтвердить отправить карту в архив?"}
                modalOpen={modalOpenSendToArchive}
                handleClose={handleCloseModalToArchive}
                handleSubmit={handleSubmitSendToArchive}
                action={"Подтвердить"}
            />
            <ModalConfirm
                title={"Подтвердить отправить на закупку резервы карт раскроя?"}
                modalOpen={modalOpenPurchase}
                handleClose={handleCloseModalPurchase}
                handleSubmit={handleSubmitModalPurchase}
                action={"Подтвердить"}
            />
            <ModalConfirm
                title={"Подтвердить карты?"}
                modalOpen={modalApprove}
                handleClose={handleCloseModalApprove}
                handleSubmit={handleSubmitModalApprove}
                action={"Подтвердить"}
            />
            <ModalConfirm
                title={"Раскроить карты?"}
                modalOpen={modalOpenCut}
                handleClose={handleCloseModalOpenCut}
                handleSubmit={handleSubmitModalOpenCut}
                action={"Подтвердить"}
            />
            {modalOpenFinishCutCuttingMap && <ModalFinishCutCuttingMap
                open={modalOpenFinishCutCuttingMap}
                handleClose={handleCloseSetFinishCut}
                handleSubmit={handleSubmitSetFinishCut}
                action={"Подтвердить"}
                currentIdRow={currentIdRow}
                cuttingMapName={finishCuttingMapName}
                unableCut={unableCut}
                setUnableCut={setUnableCut}
                markedWorkers={markedWorkers}
                setMarkedWorkers={setMarkedWorkers}
                handleModalAlert={handleModalAlert}
            />}
            <NameModal
                title="Создать комментарий"
                label="Комментарий"
                open={modalNoteOpen}
                onClose={handleCloseNoteModal}
                handleSubmit={handleSubmitNote}
                initValue={{name: currentNoteRow?.note ?? ""}}
                loading={noteLoading}
            />
        </Box>
    );
};

export default WorkingCuttingMapTable;